import React, { useState, useEffect, useRef, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Contextone } from './Context';

function NewLanguagepage() {
    const [languages, setLanguages] = useState([]);
    const history = useHistory();
    const countercontext = useContext(Contextone);
    const url = countercontext.isDomain;
    const apiUrl = `https://${url}`;

    // This function navigates to the selected language page
    const handleLanguageClick = (language) => {
        history.push(`/language/${language.name}/${language.id}`);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiUrl}/api/get_language`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                    }
                });
                const data = await response.json();
                setLanguages(data.result);

            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchData();
    }, [apiUrl]);

    return (
        <div className="container mt-4">
            <div className="row">
                <h1 class='h1'>Languages</h1>
                {languages.map((language) => (
                    <div className="col-md-4 mb-4" key={language.id}>
                        <div 
                            className="card" 
                            style={{
                                position:'relative',
                                cursor: 'pointer',
                                padding: '20px',
                                textAlign: 'center',
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #ddd',
                                bottom:'17vh',
                                
                            }}
                            onClick={() => handleLanguageClick(language)}
                        >
                            <h5>{language.name}</h5>
                            
                        </div>
                        
                    </div>
                    
                ))}
            </div>
        </div>
        
    );
}

export default NewLanguagepage;



































// import React from 'react'
// import  { useState, useEffect, useRef, useContext } from 'react';
// import { useHistory } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { Contextone } from './Context';



// function NewLanguagepage() {
//     const [languages, setLanguages] = useState([]);
//     const [selectedLanguages, setSelectedLanguages] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const LanguageRef = useRef(null);
//     const history = useHistory();
//     const countercontext = useContext(Contextone);
//     const url = countercontext.isDomain;
//     const apiUrl = `https://${url}`;
    
//     const handleCheckboxChange = (event, language) => {
//         if (event.target.checked) {
//             setSelectedLanguages([...selectedLanguages, language.id]);
//         } else {
//             setSelectedLanguages(selectedLanguages.filter(id => id !== language.id));
//         }
//     };

//     const handleSubmit = () => {
//         if (selectedLanguages.length > 0) {
//             const lid = selectedLanguages.join(',');
//             history.push(`/LanguageData/${lid}`);
//             setShowDropdown(false)
//             setSelectedLanguages([]);
//         }
//     };
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch(`${apiUrl}/api/get_language`, {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json; charset=UTF-8',
//                     }
//                 });
//                 const data = await response.json();
//                 setLanguages(data.result);
//             } catch (error) {
//                 console.error('Error:', error);
//             }
//         };

//         fetchData();
//     }, []);

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const handleLogoClick = () => {
//         setShowDropdown(!showDropdown);
//     };

//     const handleClickOutside = (event) => {
//         if (LanguageRef.current && !LanguageRef.current.contains(event.target)) {
//             setShowDropdown(false);
//         }
//     };

   

  




//   return (
//     <div className="dropdown" ref={LanguageRef}> 
//     <img
//         // src={logo}
//         alt="Toggle Dropdown"
//         className="dropdown-toggle"
//         style={{
//             marginBottom: "25px",
//             cursor: "pointer",
//             marginRight: "10px",
//             width: "25px",
//         }}
//         onClick={handleLogoClick}
//         // onClick={gotonewLanguagepage}
//     />
//     {/* {showDropdown && ( */}
//         {/* // <ul ref={LanguageRef} className={`dropdown-menu ${showDropdown ? 'show' : ''}`}> */}
//             {languages.map((language, index) => (
//                 <li key={index} className="dropdown-item">
//                     {/* <label> */}
//                     {/* <div className="form-check">
//                         <input
//                             className="form-check-input"    
//                             type="checkbox"
//                             value={language.id}
//                             onChange={(e) => handleCheckboxChange(e, language)}
//                         /> */}
//                       <a href="" onClick={handleSubmit}>
//                         { language.name}
//                         </a>
//                         {/* </label> */}
//                     {/* </div> */}
//                 </li>
//             ))}
             
//             {/* <li>
//                 <button className="btn btn-primary mt-2" style={{ marginLeft: '30px' }} onClick={handleSubmit}>
//                     Submit
//                 </button>
//             </li>
//         {/* </ul> */}
//     {/* )} */}
// </div>
// );
// }


// export default NewLanguagepage;